import { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import { useMutation } from '@apollo/client'
import styles from './deleteStaffWorkDialog.module.scss'
import Dialog from '@/components/_custom/Dialog/Dialog'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import { Close, Delete } from '@mui/icons-material'
import { DELETE_INTERNAL_WORK } from '@/modules/API/work/internalWork'
import { useNotification } from '@/modules/context/NotificationContext.tsx'

interface DeleteStaffWorkDialogProps {
    open: boolean
    handleClose: () => void
    workId: number
    daycareId?: number
    refetch: () => void
    closeParentDialog?: () => void
}

const DeleteStaffWorkDialog: FunctionComponent<DeleteStaffWorkDialogProps> = ({
    open,
    handleClose,
    workId,
    daycareId,
    refetch,
    closeParentDialog
}: DeleteStaffWorkDialogProps) => {
    const { t } = useTranslation()

    const { showNotificationSuccess, showNotificationError } = useNotification()

    const [delinkStaff] = useMutation(DELETE_INTERNAL_WORK, {
        variables: {
            workId: workId,
            daycareId: daycareId
        },
        onCompleted: () => {
            showNotificationSuccess(t('workDeleted'))

            refetch()
            handleClose()

            if (closeParentDialog) {
                closeParentDialog()
            }
        },
        onError: () => {
            showNotificationError(t('errorDeletedWork'))
        }
    })

    return (
        <Dialog open={open} handleClose={handleClose} className={styles.Dialog}>
            <DialogHeader title={t('confirmDeleteWork')} />
            <DialogBody className={styles.DialogBody}>
                <p className={styles.Text}>{t('confirmDeleteWorkMessage')}</p>
                <p className={styles.Text}>{t('noRollBack')}</p>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('yes')}
                        customIcon={<Delete />}
                        onClick={delinkStaff}
                        className={styles.Button}
                    />
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('no')}
                        customIcon={<Close />}
                        onClick={handleClose}
                        className={styles.Button}
                    />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default DeleteStaffWorkDialog
